import * as R from 'ramda';

export const containedIn = R.flip(R.includes);

export const toArray = R.compose(R.unless(R.is(Array), R.of(Array)), R.defaultTo([]));

export const mapIndexed = R.addIndex(R.map);

export const swapIndexes = R.curry(function swapIndexes(i, k, list) {
  function swappedIndex(index) {
    if (index == i) return k;
    if (index == k) return i;
    return index;
  }

  return mapIndexed((_, index) => list[swappedIndex(index)], list);
});

export const swapDown = index => swapIndexes(index, index-1);
export const swapUp = index => swapIndexes(index, index+1);

export const toggleValueInList = (toggled, equals = R.equals) =>
  R.ifElse(
    R.any(equals(toggled)),
    R.reject(equals(toggled)),
    R.append(toggled)
  );



// WEBPACK FOOTER //
// ./modules/issFrontend/utils/functional.js